/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import {
  // addDocument,
  addSubDocument,
  deleteSubDocument,
  generateIdSubDocument,
  getDocument,
  getDocuments,
  getSubDocument,
  getSubDocuments,
  getSubDocumentsWithQuerys,
  incrementFieldInSubDocument,
  setSubDocument,
  updateArrayInSubDocument,
  updateSubDocument,
} from '../../../../firebase/firestore'
import { GetPaginationCollection } from '../../../../firebase/functions'
import { CreateSearchField } from '../../../../utils/createSeachField'
import { DataComTraçoParaDataComBarra, DateNow, DateTimeNow } from '../../../../utils/dates'
import { ExportAllWorkingTimeRegister, ExportToExcel } from '../../../../utils/exportToExcel'
import { TryCatch } from '../../../../utils/general'
import { TransformationforMask } from '../../../../utils/masks'
import { ReadExcelFile } from '../../../../utils/readExcel'
import { SetHistoryEvent } from '../../../../utils/requests'
import { schemaExportAllStaff } from '../../../../utils/schemaExports'
import { sendNotification } from '../../../../utils/sendNotification'
import { HandleExportPaymentSheet } from '../_spreadsheets/exportPaymentSheet'
import { FilteredQuery } from '../_utils/filteredQuery'
import { statusStaff } from '../_utils/statusCandidate'
// import textsNotifications from '../../../../configs/textNotifications'

export const useClientEventsStaff = () => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    dataContext,
    setDataContext, // contexto que guarda dados de lista para a pagina
    infosContext,
    setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    formContext,
    setFormContext, // contexto que guarda dados de formularios da pagina
  } = useGlobalContext()

  const { id } = useParams()

  const clientId = user?.client?.id

  const [searchParams, setSearchParams] = useSearchParams()

  const [filter, setFilter] = useState({
    date: 'todos',
    round: 'todos',
    idPosition: 'todos',
    status: [],
    filtered: false,
    score: 'todos',
    location: 'todos',
  })

  const [checks, setChecks] = useState({})

  const [checkAll, setCheckall] = useState(false)

  const [page, setPage] = useState(1)

  const [searchFavorite, setSearchFavorite] = useState('')

  const [modalInvite, setModalInvite] = useState(false)

  const [modalAdd, setModalAdd] = useState(false)

  const [modalInfoCandidacy, setModalInfoCandidacy] = useState(false)

  const [modalUploadPayments, setModalUploadPayments] = useState(false)

  const [modalRegisterWorkingHours, setModalRegisterWorkingHours] = useState(false)

  const [showFilters, setShowFilters] = useState(false)

  const staffCacheRef = useRef({})

  const { date, round, idPosition, status, search = '', score, location } = filter || {}
  const dataStaff = dataContext?.staff?.data || []
  const normalizedSearch = search.toLowerCase().trim()

  const [dataStaffFiltered, setDataStaffFiltered] = useState(dataStaff)

  const [optionsFilter, setOptionsFilter] = useState({})

  const filterConfigs = useMemo(() => {
    if (!optionsFilter || !Object.keys(optionsFilter).length) return []

    return [
      {
        label: 'Data',
        field: 'date',
        options: optionsFilter?.dates?.map((date) => ({
          value: date,
          label: DataComTraçoParaDataComBarra(date),
        })),
        type: 'selectSearch',
      },
      {
        label: 'Vaga',
        field: 'idPosition',
        options: optionsFilter?.positions?.map((position) => ({
          value: position,
          label: infosContext?.positionsById[position],
        })),
        type: 'selectSearch',
      },
      {
        label: 'Turno',
        field: 'round',
        options: optionsFilter?.rounds?.map((round) => ({
          value: round,
          label: round,
        })),
        type: 'selectSearch',
      },
      {
        label: 'Status',
        field: 'status',
        options: Object.keys(statusStaff).map((status) => ({
          value: status,
          label: `${status} - ${statusStaff[status].status}`,
        })),
        type: 'selectSearchMulti',
      },
      {
        label: 'Score',
        field: 'score',
        options: [
          { value: 'alta', label: 'Alta' },
          { value: 'media', label: 'Média' },
          { value: 'baixa', label: 'Baixa' },
        ],
        type: 'selectSearch',
      },
      {
        label: 'Cidade/Estado',
        field: 'location',
        options: optionsFilter?.locations?.map((loc) => ({
          value: loc,
          label: loc,
        })),
        type: 'selectSearch',
      },
    ]
  }, [optionsFilter, infosContext, statusStaff])

  const getFilterLabel = (key, value) => {
    if (!value || value === 'todos') return null
    let displayValue = value

    switch (key) {
      case 'date':
        displayValue = DataComTraçoParaDataComBarra(value)
        break
      case 'idPosition':
        displayValue = infosContext?.positionsById[value] || value
        break
      case 'status': {
        const arr = Array.isArray(value) ? value : [value]
        displayValue = arr.map((v) => statusStaff[v]?.status || v)
        break
      }
      case 'score':
        displayValue = value.charAt(0).toUpperCase() + value.slice(1)
        break
      case 'location':
        displayValue = value
        break
      case 'round':
        displayValue = value
        break
      default:
        displayValue = value
    }

    // Retorna no formato "NomeDoFiltro: Valor"
    const filterNameMap = {
      date: 'Data',
      idPosition: 'Vaga',
      status: 'Status',
      score: 'Score',
      location: 'Cidade/Estado',
      round: 'Turno',
    }

    return `${filterNameMap[key] || key}: ${displayValue}`
  }

  const handleFilter = async (currentData = dataStaff) => {
    const filtered = currentData
      .filter((item) => {
        const job = item?.jobOffer || {}
        const scoreValue = Number(item?.collabData?.positions?.[job.idPosition]?.score || 0)
        const locationValue = `${item?.collabData?.address?.city + ' / ' + item?.collabData?.address?.state}`

        if (date !== 'todos' && job.date !== date) return false
        if (round !== 'todos' && job.round !== round) return false
        if (idPosition !== 'todos' && job.idPosition !== idPosition) return false

        const statusArr = Array.isArray(status) ? status : [status]
        if (statusArr.length > 0) {
          if (!statusArr.includes(String(item.status))) return false
        }

        if (location !== 'todos' && locationValue !== location) return false
        if (score !== 'todos') {
          if (score === 'alta' && !(scoreValue >= 4 && scoreValue <= 5)) return false
          if (score === 'media' && !(scoreValue >= 2 && scoreValue < 4)) return false
          if (score === 'baixa' && !(scoreValue < 2)) return false
        }

        if (normalizedSearch) {
          const name = (item.name || '').toLowerCase()
          const cpf = String(item.cpf || '').toLowerCase()
          const nome = (item.nome || '').toLowerCase()
          const match =
            name.includes(normalizedSearch) || nome.includes(normalizedSearch) || cpf.includes(normalizedSearch)
          if (!match) return false
        }

        return true
      })
      .sort((a, b) => {
        // status 0 sempre primeiro
        if (a.status === 0 && b.status !== 0) return -1
        if (a.status !== 0 && b.status === 0) return 1

        const parse = (str) => {
          if (!str) return 0
          const [date, time] = str.split(' ')
          const [d, m, y] = date.split('/')
          return new Date(`${y}-${m}-${d}T${time}`).getTime()
        }

        return parse(b.dt_created) - parse(a.dt_created)
      })

    setDataStaffFiltered(filtered)
    setShowFilters(false)

    const params = {}
    Object.entries(filter).forEach(([key, value]) => {
      if (value) params[key] = value
    })
    setSearchParams(params)
  }

  const getAllStaff = async () => {
    const getStaff = await getSubDocuments('events', id, 'staff')
    const getJobOffers = await getSubDocuments('events', id, 'jobOffers')
    const getPositions = await getDocuments('cargos')

    const staffEnriched = getStaff.map((staff) => {
      const { idJobOffers } = staff
      const jobOfferData = getJobOffers.find((key) => key.id === idJobOffers)

      if (!jobOfferData) return { ...staff, position: null, jobOffer: null }

      const position = (getPositions || []).find((pos) => pos.id === jobOfferData.idPosition)

      return { ...staff, jobOffer: { ...jobOfferData, position } }
    })

    const stafferTotal = await Promise.all(
      staffEnriched.map(async (candidacy) => {
        const uuid = candidacy?.uuid
        if (!uuid) return candidacy

        const cached = staffCacheRef.current[uuid]
        if (cached) return { ...candidacy, collabData: cached }

        try {
          const staffer = await getDocument('colaboradores', uuid)
          const safeData = staffer || {}

          // salva no cache
          staffCacheRef.current[uuid] = safeData

          return { ...candidacy, collabData: safeData }
        } catch (err) {
          console.error('Erro ao buscar colaborador:', uuid, err)
          return candidacy
        }
      }),
    )

    return stafferTotal
  }

  // seta os valores na url da pagina
  const setQueryInURL = async (query, more = {}) => {
    const filteredQuery = FilteredQuery(query)

    // seta nos parametros da url um novo filtro
    const newQuery = await schemaUrlParams({ ...filteredQuery, ...more })

    // setSearchParams((prev) => ({ ...prev, ...newQuery }))
  }

  // schema para subir na url da pagina quando pesquisar
  const schemaUrlParams = async (params) => {
    const filteredParams = {
      page: params?.page === 'null' ? 'todos' : params?.page,
      date: params?.date === 'null' ? 'todos' : params?.date,
      round: params?.date === 'null' ? 'todos' : params?.date,
      status: params?.status === 'null' ? 'todos' : params?.status,
      idPosition: params?.idPosition === 'null' ? 'todos' : params?.idPosition,
      idJobOffers: Array.isArray(params?.idJobOffers) && params.idJobOffers.length > 0 ? params.idJobOffers : undefined,
      filtered: params?.filtered === 'null' ? 'todos' : params?.filtered,
    }

    // Remove propriedades com valor undefined
    return FilteredQuery(filteredParams)
  }

  const getSearchParam = (key, defaultValue = null, parseNumber = false) => {
    const value = searchParams.get(key)
    if (!value || value === 'todos') return defaultValue
    return parseNumber ? Number(value) : value
  }

  // atualiza os filtro com base nos parametros da pagina
  const updateFiltersByUrlParams = async (query, pageQuery) => {
    let newQuery = null
    let newFilter
    let page = 1
    if (pageQuery !== null) {
      page = pageQuery
    }
    if (query) {
      newQuery = { ...query, page }
      newFilter = { ...newQuery }
    } else {
      // caso não tenha query, ele busca na url e salva no filtro caso tenha algo
      const idJobOffers = searchParams.getAll('idJobOffers') // continua como array
      const status = getSearchParam('status', 'todos', true) // se número válido, converte
      const search = getSearchParam('search', '')
      const date = getSearchParam('date')
      const idPosition = getSearchParam('idPosition')
      const round = getSearchParam('round')
      // Crie um novo objeto de consulta sem redefinir a variável 'query'
      newFilter = { idJobOffers, status, search, page, idPosition, date, round }
      newQuery = FilteredQuery(newFilter)
    }

    newFilter = {
      ...newFilter,
      filtered: newQuery?.status !== null && !isNaN(newQuery?.status) && newQuery?.status !== 'todos', // caso true, aparece os checkBox na frente do colaborador
    }
    // console.log(!isNaN(newQuery?.status))
    // console.log(newFilter)
    // setFilter(newFilter)
    setChecks({})
    await setQueryInURL(newQuery)
    return { newQuery }
  }

  // coleta os dados da staff do evento
  const getDatas = async ({ query = null, pageQuery = null, limit = 500 } = {}) => {
    const getEventData = await getDocument('events', id)
    const eventData = {
      ...getEventData,
      ...getEventData.address,
      statusEvent: getEventData.status,
    }
    // console.log(eventData)
    setFormContext((prev) => ({ ...prev, ...eventData }))

    await setDataContext({})

    // atualiza os paremtros com a query nova, ou busca da url da pagina
    const { newQuery } = await updateFiltersByUrlParams(query, pageQuery)

    const newPage = newQuery?.page || 1

    const getStaff = await getAllStaff()
    // const getStaff = await GetPaginationStaff(newPage, limit, id, newQuery, { field: 'status', direction: 'asc' })

    const uniqueLocations = Array.from(
      new Set(
        getStaff
          .map((staff) => {
            const city = staff.collabData?.address?.city?.trim()
            const state = staff.collabData?.address?.state?.trim()
            // concatena cidade e estado para gerar valor único
            return city && state ? `${city} / ${state}` : null
          })
          .filter(Boolean), // remove nulls/undefined
      ),
    )

    setOptionsFilter((prev) => ({ ...prev, locations: uniqueLocations }))

    const newData = {
      staff: {
        data: getStaff,
        pagination: {
          totalItems: getStaff.length,
          currentPage: 1,
          totalPages: 1,
          itemsPerPage: 100,
        },
      },
    }

    setDataContext((prev) => ({ ...prev, ...newData }))

    return newData
  }

  const checkedIds = new Set(Object.keys(checks || {}))

  const checked = dataStaffFiltered.filter((c) => checkedIds.has(c.id))

  const checkedWithCollab = checked.filter((c) => c?.collabData && Object.keys(c.collabData).length > 0)

  const allUuidsListCheckeds = checkedWithCollab.map((c) => c.uuid)
  const allTokensListCheckeds = checkedWithCollab.map((c) => c?.collabData?.token)

  const getDataFavorites = async (query = null) => {
    const querys = [{ field: 'cpf', operator: '==', value: String(searchFavorite).toLowerCase().trim() }]

    const getCollaboratorPagination = await GetPaginationCollection(1, 100, 'colaboradores', 'dt_created', querys)

    setDataContext((prev) => ({ ...prev, favorites: getCollaboratorPagination }))
  }

  const getInfos = async () => {
    const getJobOffers = await getSubDocuments('events', id, 'jobOffers')

    const getReportsClient = await getSubDocuments('clients', clientId, 'reports')
    const getReportsAdmin = await getDocuments('reports')

    const getPositions = await getDocuments('cargos')
    const positionsById = getPositions.reduce((acc, curr) => {
      acc[curr.id] = curr.nome
      return acc
    }, {})
    const JobOffersById = getJobOffers.reduce((acc, curr) => {
      acc[curr.id] = { ...curr, positionName: positionsById[curr.idPosition] }
      return acc
    }, {})

    const dates = []
    const positions = []
    const rounds = []

    Object.values(JobOffersById).forEach((offer) => {
      if (!dates.includes(offer.date)) {
        dates.push(offer.date)
      }
      if (!positions.includes(offer.idPosition)) {
        positions.push(offer.idPosition)
      }
      if (!rounds.includes(offer.round)) {
        rounds.push(offer.round)
      }
    })

    const filters = {
      dates,
      positions,
      rounds,
    }

    setOptionsFilter((prev) => ({ ...prev, ...filters }))

    const newInfos = {
      positions: getPositions,
      positionsById,
      jobOffers: JobOffersById,
      ListJobOffers: Object.values(JobOffersById),
      filters,
      reportsGlobal: getReportsAdmin,
      myReports: getReportsClient,
    }

    setInfosContext((prev) => ({ ...prev, ...newInfos }))
  }

  // valida e entrega o valor corretamente para o filter
  const validateFilter = (value, field, returnType = 'string') => {
    if (value?.[field] === 'todos' || value?.[field] === null) {
      return 'todos'
    } else {
      switch (returnType) {
        case 'string':
          return String(value?.[field])
        case 'number':
          return Number(value?.[field])
        default:
          return value?.[field]
      }
    }
  }

  const validateIdJobOffersByFilter = (filters) => {
    const datesByQuery = new Set()
    const positionsByQuery = new Set()
    const roundByQuery = new Set()

    Object.values(infosContext?.jobOffers).forEach((jobOffer) => {
      if (filters?.date && jobOffer.date === filters?.date && jobOffer.date !== 'todos') {
        datesByQuery.add(jobOffer.id)
      }
      if (filters?.position && jobOffer.idPosition === filters?.position && jobOffer.idPosition !== 'todos') {
        positionsByQuery.add(jobOffer.id)
      }
      if (filters?.round && jobOffer.round === filters?.round && jobOffer.round !== 'todos') {
        roundByQuery.add(jobOffer.id)
      }
    })

    let idJobOffers = []

    if (datesByQuery.size === 0 && positionsByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = []
    } else if (datesByQuery.size === 0 && positionsByQuery.size === 0) {
      idJobOffers = Array.from(roundByQuery)
    } else if (datesByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = Array.from(positionsByQuery)
    } else if (positionsByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = Array.from(datesByQuery)
    } else {
      idJobOffers = Array.from(datesByQuery)
        .filter((id) => positionsByQuery.size === 0 || positionsByQuery.has(id))
        .filter((id) => roundByQuery.size === 0 || roundByQuery.has(id))
    }

    return idJobOffers
  }

  // coleta os dados da staff com evento usando uma pesquisa
  const queryData = async () => {
    const date = validateFilter(filter, 'date')
    const position = validateFilter(filter, 'idPosition')
    const status = validateFilter(filter, 'status', 'number')
    const round = validateFilter(filter, 'round')

    const idJobOffers = validateIdJobOffersByFilter({ date, position, status, round })

    const query = {
      ...filter,
      status,
      date,
      idPosition: position,
      round,
      idJobOffers,
    }
    if (query.idJobOffers.length === 0 && date !== 'todos' && position !== 'todos' && round !== 'todos') {
      return setAlerts((prev) => [
        ...prev,
        [
          ...prev,
          {
            type: 'error',
            title: 'Vaga não encontrada',
            msg: `Não existe a vaga de ${infosContext?.positionsById[position]} para o dia ${date}, selecione um filtro valido, ou crie uma nova vaga.`,
          },
        ],
      ])
    }
    delete query.filtered

    const filteredQuery = FilteredQuery({ ...query, page: 1 })

    setPage(1)
    await getDatas({ query: filteredQuery, pageQuery: 1 })
  }

  // realiza a limpeza da pagina
  const clearQueryData = async () => {
    const clear = {
      date: 'todos',
      idPosition: 'todos',
      status: 'todos',
      score: 'todos',
      location: 'todos',
      round: 'todos',
    }
    await setFilter(clear)
    await handleFilter()
  }

  const updateValuesInfoCandidacy = async (value) => {
    const favorite = await checkFavoriteColaborator(value?.uuid)
    const blocked = await checkBlockColaborator(value?.uuid)
    const newValuesInfoCandidacy = {
      ...value,
      status: statusStaff[Number(value.status)] || '',
      favorite,
      blocked,
    }
    SetValuesInfoCandidacy(newValuesInfoCandidacy)
  }

  const checkFavoriteColaborator = async (uuidColab) => {
    const idClient = user?.client?.id
    if (!idClient) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'ID do Cliente Inexistente',
          msg: 'Por favor, faça login novamente para obtermos o ID do cliente logado.',
        },
      ])
      return false
    }

    try {
      const favorite = await getSubDocument('clientes', idClient, 'favorites', uuidColab)
      return !!favorite
    } catch (error) {
      return false
    }
  }

  const checkBlockColaborator = async (uuidColab) => {
    const idClient = user?.client?.id
    if (!idClient) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'ID do Cliente Inexistente',
          msg: 'Por favor, faça login novamente para obtermos o ID do cliente logado.',
        },
      ])
      return false
    }

    try {
      const favorite = await getSubDocument('colaboradores', uuidColab, 'blockedIn', idClient)
      return !!favorite
    } catch (error) {
      return false
    }
  }

  const favoriteColaborator = async (uuidColab) => {
    if (!user.user.permissions.favorites_add) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    const idClient = user?.client?.id
    if (!idClient) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'ID do Cliente Inexistente',
          msg: 'Por favor, faça login novamente para obtermos o ID do cliente logado.',
        },
      ])
    }
    const existFavorite = await checkFavoriteColaborator(uuidColab)
    if (!existFavorite) {
      let getColab
      try {
        getColab = await getDocument('colaboradores', uuidColab)
      } catch (error) {
        return setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Colaborador não existe',
            msg: 'O Colaborador não existe ou não excluiu o registro em nosso sistema: ' + error,
          },
        ])
      }

      if (getColab) {
        await setSubDocument('clientes', idClient, 'favorites', uuidColab, {
          uuid: uuidColab,
          dt_created: DateTimeNow(),
          dt_assigned: DateTimeNow(),
          search: CreateSearchField(getColab),
          status: true,
        })
        await setSubDocument('colaboradores', uuidColab, 'favorites', idClient, {
          idClient: user.client.id,
          dt_created: DateTimeNow(),
          dt_assigned: DateTimeNow(),
          status: true,
        })
        const token = getColab?.token || null

        const tokenAsArray = [token]

        const notificationFields = {
          title: 'Favoritado',
          description: 'Uma empresa favoritou você!',
        }
        await sendNotification(uuidColab, tokenAsArray, notificationFields.title, notificationFields.description)

        setFormContext((prev) => ({ ...prev, favorite: true }))
      } else {
        throw new Error('Colaborador não encontrado, ou excluido da base de dados...')
      }
    } else {
      await deleteSubDocument('clientes', idClient, 'favorites', uuidColab)
      setFormContext((prev) => ({ ...prev, favorite: false }))
    }

    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        msg: `Colaborador ${existFavorite ? 'removido dos' : 'adicionado aos'}  favoritos com sucesso`,
      },
    ])
  }

  const blockUnBlockColaborator = async (uuidColab) => {
    if (!user.user.permissions.blockeds_add) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    const idClient = user?.client?.id
    if (!idClient) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'ID do Cliente Inexistente',
          msg: 'Por favor, faça login novamente para obtermos o ID do cliente logado.',
        },
      ])
    }
    const existFavorite = await checkBlockColaborator(uuidColab)
    if (!existFavorite) {
      const reason = window.prompt('Nos conte o motivo do bloqueio do colaborador: ')

      if (reason === '' || reason === null) {
        return setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Motivo obrigatório',
            msg: 'Para bloquear o colaborador, é necessario informar o moivo da ação.',
          },
        ])
      }
      const newBlocked = {
        dt_created: DateTimeNow(),
        reason,
        createdBy: user.user.nome,
      }

      try {
        const colab = await getDocument('colaboradores', uuidColab)
        await setSubDocument('colaboradores', uuidColab, 'blockedIn', idClient, { ...newBlocked, idClient })
        await setSubDocument('clientes', idClient, 'blockeds', uuidColab, {
          ...newBlocked,
          uuid: uuidColab,
          search: CreateSearchField(colab),
        })
      } catch (e) {
        return setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Colaborador não existe',
            msg: 'O Colaborador não existe ou não excluiu o registro em nosso sistema: ' + e,
          },
        ])
      }

      setFormContext((prev) => ({ ...prev, blocked: true }))
    } else {
      await deleteSubDocument('colaboradores', uuidColab, 'blockedIn', idClient)
      await deleteSubDocument('clientes', idClient, 'blockeds', uuidColab)
      setFormContext((prev) => ({ ...prev, blocked: false }))
    }

    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: `Candidatura ${!existFavorite ? 'Bloqueada' : 'Desbloqueada'}`,
        msg: !existFavorite
          ? 'o colaborador não pode mais se candidatar em seus eventos'
          : 'o colaborador pode voltar a se candidatar em seus eventos',
      },
    ])
  }

  const exportAllData = async () => {
    if (!user.user.permissions.staffEvent_exportSheets) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: `Exportando Planilha`,
        msg: 'Estamos coletando as informações necessárias para gerar sua planilha. Esse processo pode levar alguns minutos...',
      },
    ])
    const newLimit = dataContext?.staff?.pagination?.totalItems || 5000
    const data = await getDatas({ limit: newLimit })
    const jobOffers = infosContext?.jobOffers || null
    const dataEnriched = data.staff.data.map((values) => {
      const idJobOffer = values?.idJobOffers
      const status = values?.status
      return {
        ...values,
        jobOffersName: jobOffers[idJobOffer].positionName,
        date: jobOffers[idJobOffer].date,
        statusPlus: statusStaff[status] || { status: 'Sem status' },
      }
    })

    const response = schemaExportAllStaff(dataEnriched)

    ExportToExcel(response, `Staff_${id}.xlsx`)

    await SetHistoryEvent(id, user.user.nome, `Planilha de Staff Esportada`)
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: `Planilha Conclúida`,
        msg: 'O Processo de construir sua planilha terminou com exito...',
      },
    ])
  }

  const criar1000Candidaturas = async () => {
    try {
      const jobs = await getSubDocuments('events', id, 'jobOffers')
      const idJobs = jobs.map((job) => job.id)

      const colabs = await getDocuments('colaboradores')
      const idColabs = colabs.map((colab) => colab.id)

      const quant = prompt('Quantos colaboradores vc deseja incluir? ', 5)

      const promisses = Array.from({ length: quant }).map(async () => {
        const status = 3
        const idJobOffers = idJobs[Math.floor(Math.random() * idJobs.length)]
        const uuid = idColabs[Math.floor(Math.random() * idColabs.length)]
        const newID = await generateIdSubDocument('events', id, 'staff')
        const newCandidatura = {
          status,
          idJobOffers,
          uuid,
          dt_created: DateTimeNow(),
        }
        const newCandidacy = {
          idEvent: id,
          idCandidacy: newID,
          dt_created: DateTimeNow(),
        }
        await setSubDocument('events', id, 'staff', newID, newCandidatura)
        await setSubDocument('colaboradores', uuid, 'candidacys', newID, newCandidacy)
      })

      await Promise.all(promisses)

      alert('Colaboradores cadastrados')

      FetchGetdatas()
    } catch (error) {
      console.error('Erro ao criar candidaturas:', error)
      alert('Ocorreu um erro ao cadastrar colaboradores.')
    }
  }

  const createSchemaInviteTeams = async (values) => {
    const t = true
    if (t) return
    const jobId = values?.jobInvite || false
    const teamId = values?.teamId || false

    if (!jobId || !teamId) {
      return { error: 'Selecione um "vaga" e uma "equipe" para enviar o convite' }
    }

    const jobOffer = infosContext?.jobOffers?.[jobId] || false

    if (!jobOffer) {
      return { error: 'Vaga selecionada não existe, ou foi excluida da sua base de dados' }
    }

    const getTeam = await getSubDocument('clientes', clientId, 'teams', teamId)

    const teamList = getTeam?.teams || []

    if (teamList.length === 0) {
      return { error: 'Equipe selecionada não possui colaboradores, revie-a antes de enviar o convite' }
    }

    const newCandidacies = teamList.flatMap((colab) => {
      return {
        uuid: colab.uuid,
        idJobOffers: jobId,
        status: 2,
        search: CreateSearchField(colab),
        dt_created: DateTimeNow(),
        name: values.name,
      }
    })

    return { data: newCandidacies }
  }

  const inviteTeams = async (values) => {
    if (!user.user.permissions.staffEvent_invite) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    try {
      const candidacies = await createSchemaInviteTeams(values)

      if (candidacies?.error) {
        return setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Erro ao criar convite',
            msg: candidacies?.error,
          },
        ])
      }

      const promises = candidacies.data.map(async (candidacy) => {
        let candacysExists = []
        if (candidacy?.uuid !== undefined) {
          const query = [
            { field: 'uuid', operator: '==', value: candidacy?.uuid },
            { field: 'idJobOffers', operator: '==', value: candidacy?.idJobOffers },
            { field: 'status', operator: 'in', value: [0, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
          ]
          candacysExists = await getSubDocumentsWithQuerys('events', id, 'staff', query, 1)
        }
        if (candacysExists.length === 0) {
          const idJobOffer = candidacy?.idJobOffers
          if (idJobOffer) {
            try {
              const idCandidacy = await addSubDocument('events', id, 'staff', candidacy)
              const DateJobOffer = infosContext?.jobOffers?.[idJobOffer].date
              const newCandidacyColab = {
                idCandidacy,
                idEvent: id,
                date: DateJobOffer,
                status: candidacy.status,
                idJobOffers: candidacy.idJobOffers,
                dt_created: DateNow(),
              }
              await addSubDocument('colaboradores', candidacy.uuid, 'candidacys', newCandidacyColab)
              await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffer, 'filledJob', 1)
            } catch (e) {
              setAlerts((prev) => [
                ...prev,
                {
                  type: 'error',
                  title: 'Colaborador não encontrado',
                  msg: 'Algum colaborador na sua equipe, não existe ou excluir o perfil em nossos banco de dados...',
                },
              ])
            }
          }
        }
      })

      await Promise.all(promises)

      setAlerts((prev) => [
        ...prev,
        {
          type: 'success',
          title: 'Convite enviado a Equipe',
          msg: 'Foram enviados convites aos membros da equipe, aguarde a confirmação deles...',
        },
      ])
      await SetHistoryEvent(id, user.user.nome, [
        `Convite enviado a Equipe: ${infosContext?.teams.filter((teams) => teams.id === formContext?.teamId)[0].name}`,
        `Data: ${values?.dateInvite}`,
      ])
      setFormContext((prev) => ({ ...prev, dateInvite: null, teamId: null }))
      setModalInvite(false)
      FetchGetdatas()
    } catch (error) {
      throw new Error(error)
    }
  }

  const addCandidacy = async (values) => {
    if (!user.user.permissions.staffEvent_add) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }

    const jobInvite = values?.jobInvite

    if (!jobInvite) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Cargo Inválido',
          msg: 'Precisa selecionar um cargo.',
        },
      ])
    }

    const positionIdOfJobInvite = (infosContext?.ListJobOffers || []).find((job) => job.id === jobInvite)

    const idPosition = positionIdOfJobInvite?.idPosition || null

    const positionInfos = (infosContext?.positions || []).find((job) => job.id === idPosition)

    const hasPosition = Object.entries(values?.positions || {}).some((position) => position[0] === idPosition)

    if (!hasPosition) {
      const newPosition = {
        [idPosition]: {
          scoreMultiply: positionInfos.scoreMultiply,
          id: idPosition,
          main: false,
          myEnterprises: user.client.nomeFantasia,
          name: positionIdOfJobInvite.positionName,
          status: 1,
          myExperiences: `Cargo adicionado pela empresa: ${user.client.nomeFantasia}`,
          score: 0,
          validationBy: user.user.nome || user.user.name,
          validationReason: `Cargo adicionado pela empresa: ${user.client.nomeFantasia}`,
          validationDate: DateTimeNow(),
        },
      }

      const docPromises = positionInfos?.documentos.map(async (docId) => {
        if (!values?.documents?.[docId]) {
          const docInfo = await getDocument('documentos', docId)
          return {
            docId,
            data: {
              status: false,
              urlSubmit: '',
              name: docInfo.name,
              syncField: '',
              sendDate: '',
              expired: docInfo?.docExpired ?? false,
            },
          }
        }
        return null
      })

      const conPromises = positionInfos?.consentimentos.map(async (conId) => {
        if (!values?.consents?.[conId]) {
          const conInfo = await getDocument('consentimentos', conId)
          return {
            conId,
            data: {
              status: false,
              name: conInfo.name,
              syncField: '',
              signDate: '',
              expired: conInfo?.consExpired ?? false,
            },
          }
        }
        return null
      })

      const notificationFields = {
        title: `Novo cargo: ${positionIdOfJobInvite.positionName}`,
        description: `A empresa ${user.client.nomeFantasia} te adicionou ao cargo de ${positionIdOfJobInvite.positionName}. Acesse para verificar documentos pendentes ou consentimentos a assinar.`,
      }

      await sendNotification([values.id], [values.token], notificationFields.title, notificationFields.description)
    }

    const schemaStaff = {
      uuid: values.id,
      jobInvite: values.jobInvite,
      name: values.name,
      cpf: values.cpf,
      token: values.token,
    }

    const uuid = schemaStaff.uuid
    const jobId = schemaStaff?.jobInvite || false

    if (!jobId) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Erro ao criar convite',
          msg: 'Vaga não selecionada',
        },
      ])
    }

    const candidacy = {
      uuid,
      idJobOffers: jobId,
      status: 2,
      search: CreateSearchField(schemaStaff),
      dt_created: DateTimeNow(),
      name: values.name,
      cpf: values.cpf,
    }
    const query = [
      { field: 'uuid', operator: '==', value: candidacy?.uuid },
      { field: 'idJobOffers', operator: '==', value: candidacy?.idJobOffers },
      { field: 'status', operator: 'in', value: [0, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
    ]

    const candacysExists = await getSubDocumentsWithQuerys('events', id, 'staff', query, 1)

    if (candacysExists.length === 0) {
      const idJobOffer = candidacy?.idJobOffers
      if (idJobOffer) {
        try {
          const getEvent = await getDocument('events', id)
          const idCandidacy = await addSubDocument('events', id, 'staff', candidacy)
          const positionName = infosContext?.jobOffers?.[idJobOffer].positionName
          const DateJobOffer = infosContext?.jobOffers?.[idJobOffer].date
          const newCandidacyColab = {
            idCandidacy,
            idEvent: id,
            date: DateJobOffer,
            status: candidacy.status,
            idJobOffers: candidacy.idJobOffers,
            dt_created: DateNow(),
          }
          await addSubDocument('colaboradores', candidacy.uuid, 'candidacys', newCandidacyColab)
          await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffer, 'filledJob', 1)
          setAlerts((prev) => [
            ...prev,
            {
              type: 'success',
              title: 'Convite enviado a staff',
              msg: 'Seu convite ao staff foi enviado, agora aguarde que o mesmo aceite participar do evento...',
            },
          ])

          const notificationFields = {
            title: `Convite para evento ${getEvent.name} - ${getEvent.round}`,
            description: `Você foi convidado para participar do evento ${getEvent.name} - ${getEvent.round}, com o cargo de ${positionName}, para o dia ${DateJobOffer},  entre no app confirme sua presença.`,
          }

          const tokensNotifications = [schemaStaff.uuid]

          await sendNotification(
            [candidacy.uuid],
            tokensNotifications,
            notificationFields.title,
            notificationFields.description,
          )

          await SetHistoryEvent(id, user.user.nome, [
            `Convite enviado ao staff: ${candidacy.name}`,
            `Data: ${DateJobOffer}`,
            `Vaga: ${positionName}`,
          ])
          FetchGetdatas()
        } catch (e) {
          setAlerts((prev) => [
            ...prev,
            {
              type: 'error',
              title: 'Colaborador não encontrado',
              msg: 'O colaborador não existe ou excluir o perfil em nossos banco de dados...' + e,
            },
          ])
        }
      }
    } else {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Candidatura existente',
          msg: 'Esse colaborador ja foi candidatado para essa vaga',
        },
      ])
    }
  }

  const checkStatusForJustify = async (currentStatus, newStatus, nameCollaborator = null) => {
    const roleMotivo = [
      [0, 1],
      [0, 11],
      [11, 2],
      [2, 11],
      [1, 2],
      [3, 11],
    ]

    const hasmotivo = roleMotivo.some(([from, to]) => from === currentStatus && to === newStatus)

    let motivo = ''
    if (hasmotivo) {
      motivo = window.prompt(
        nameCollaborator
          ? `Deseja mudar o status de ${nameCollaborator}, para "${statusStaff[Number(status)].status}"?\n\n >>> Justifique sua mudança:`
          : `Deseja mudar o status dos ${Object.keys(checks).filter((c) => checks[c]).length} colaboradores selecinados?\n\n >>> Justifique sua mudança:`,
      )

      if (motivo === '' || motivo === null) {
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Justificativa obrigatória',
            msg: `Para realizar essa ação, é obrigatório que a justificativa`,
          },
        ])
      } else {
        return motivo
      }
    }
    return motivo
  }

  const schemaRegisterTimesPoints = ({ time = DateTimeNow(), comment = '' }) => {
    return { time, comment, registerBy: user.user.nome }
  }

  const setCheckinOrCheckout = (currentStatus, newStatus) => {
    const roleCheckin = [[3, 5]]
    const roleCheckout = [[5, 7]]

    const hasCheckin = roleCheckin.some(([from, to]) => from === currentStatus && to === newStatus)
    const hasCheckout = roleCheckout.some(([from, to]) => from === currentStatus && to === newStatus)
    if (hasCheckin) {
      return [schemaRegisterTimesPoints({ comment: 'Check-In' })]
    } else if (hasCheckout) {
      return [schemaRegisterTimesPoints({ comment: 'Check-Out' })]
    } else {
      return []
    }
  }

  const hasStatusDecrementJobOffers = (newStatus) => {
    const roledecrement = [1, 11]

    return roledecrement.includes(newStatus)
  }

  const hasStatusIncrementJobOffers = (currentStatus, newStatus) => {
    const roleIncrement = [
      [1, 2],
      [11, 2],
    ]

    const hasIncrement = roleIncrement.some(([from, to]) => from === currentStatus && to === newStatus)

    return hasIncrement
  }

  const checkPermitionForUpdateStatus = (newStatus) => {
    if (newStatus === 2 && !user.user.permissions.staffEvent_approve) {
      return true
    }
    if (newStatus === 1 && !user.user.permissions.staffEvent_reprove) {
      return true
    }
    if (newStatus === 5 && !user.user.permissions.staffEvent_checkin) {
      return true
    }
    if (newStatus === 7 && !user.user.permissions.staffEvent_checkout) {
      return true
    }
    if (newStatus === 11 && !user.user.permissions.staffEvent_cancel) {
      return true
    }
    if (newStatus === 10 && !user.user.permissions.staffEvent_payment) {
      return true
    }
    return false
  }

  const UpdateStatusCandidacy = async (status, valuesCandidacy) => {
    if (checkPermitionForUpdateStatus(status)) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }

    const idCandidacy = valuesCandidacy?.id
    const idJobOffers = valuesCandidacy?.idJobOffers
    const nameColaborador = valuesCandidacy?.name
    const dateCandidacy = infosContext?.jobOffers[idJobOffers]?.date
    const statusCurrent = valuesCandidacy?.status

    if (idCandidacy === null && nameColaborador === null && dateCandidacy === null && statusCurrent === null) {
      throw new Error(
        `Values Faltantes:
        idCandidacy:${idCandidacy}, 
        nameColaborador:${nameColaborador}, 
        dateCandidacy:${dateCandidacy}, 
        statusCurrent:${statusCurrent}`,
      )
    }
    const motivo = await checkStatusForJustify(statusCurrent, status, nameColaborador)
    if (motivo === null) return

    const newCadidacy = {
      status,
      dtUpdate: DateTimeNow(),
      userUpdate: user?.user?.nome || '',
      ...(motivo !== '' && { motivo }),
    }
    await updateSubDocument('events', id, 'staff', idCandidacy, newCadidacy)

    const hasCheckinCheckout = setCheckinOrCheckout(statusCurrent, status)
    if (hasCheckinCheckout.length > 0) {
      await updateArrayInSubDocument('events', id, 'staff', idCandidacy, 'workingHours', hasCheckinCheckout, true)
    }

    const hasIncrementJobOffers = hasStatusIncrementJobOffers(statusCurrent, status)
    if (hasIncrementJobOffers) {
      await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffers, 'filledJob', 1)
    }

    const hasDecrementJobOffers = hasStatusDecrementJobOffers(status)
    if (hasDecrementJobOffers) {
      await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffers, 'filledJob', -1)
    }

    const newData = dataContext?.staff?.data.map((cand, index) => {
      if (idCandidacy === cand.id) {
        return { ...cand, status }
      }
      return cand
    })

    await setDataContext((prev) => ({ ...prev, staff: { ...prev.staff, data: newData } }))
    await SetHistoryEvent(id, user.user.nome, [
      `Candidatura Atualizada: ${nameColaborador}`,
      `Data: ${dateCandidacy}`,
      `Novo Status "${statusStaff[Number(status)].status}`,
      ...(motivo !== '' ? [`Motivo: ${motivo}`] : []),
    ])
  }

  const UpdateStatusMultipleCandidacy = async (newStatus, ListCandidacys) => {
    if (checkPermitionForUpdateStatus(newStatus)) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }

    const IdsCandidacys = Object.keys(ListCandidacys).filter((id) => ListCandidacys[id])

    const currentStatus = (dataStaffFiltered || [])
      .map((candidacy) => {
        if (IdsCandidacys.includes(candidacy.id)) {
          return candidacy.status
        } else {
          return null
        }
      })
      .filter((s) => s !== null)

    if (currentStatus.length === 0) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Nenhum colaborador checados',
          msg: `Selecione ao menos um colaborador para continuar a ação...`,
        },
      ])
    }

    const motivo = await checkStatusForJustify(currentStatus[0], newStatus)
    if (motivo === null) return

    const newCandidacy = {
      status: newStatus,
      dtUpdate: DateTimeNow(),
      userUpdate: user?.user?.nome,
      ...(motivo !== '' && { motivo }),
    }

    let newData

    const promises = IdsCandidacys.map(async (idCandidacy) => {
      await updateSubDocument('events', id, 'staff', idCandidacy, newCandidacy)

      const hasCheckinCheckout = setCheckinOrCheckout(currentStatus[0], newStatus)
      if (hasCheckinCheckout.length > 0) {
        await updateArrayInSubDocument('events', id, 'staff', idCandidacy, 'workingHours', hasCheckinCheckout, true)
      }

      const getCandidacy = await getSubDocument('events', id, 'staff', idCandidacy, newCandidacy)

      const idJobOffers = getCandidacy?.idJobOffers

      const hasIncrementJobOffers = hasStatusIncrementJobOffers(currentStatus[0], newStatus)
      if (hasIncrementJobOffers) {
        await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffers, 'filledJob', 1)
      }

      const hasDecrementJobOffers = hasStatusDecrementJobOffers(newStatus)
      if (hasDecrementJobOffers) {
        await incrementFieldInSubDocument('events', id, 'jobOffers', idJobOffers, 'filledJob', -1)
      }
    })

    await Promise.all(promises).then(() => {
      newData = dataContext?.staff?.data.map((cand) => {
        if (IdsCandidacys.includes(cand.id)) {
          return { ...cand, status: newStatus }
        }
        return cand
      })
    })

    await setDataContext((prev) => ({ ...prev, staff: { ...prev.staff, data: newData } }))
    await SetHistoryEvent(
      id,
      user.user.nome,
      [
        `Candidaturas Atualizadas: ${IdsCandidacys.length} Selecionados`,
        `Novo Status "${statusStaff[Number(newStatus)].status}"`,
        ...(motivo !== '' ? [`Motivo: ${motivo}`] : []),
      ],
      { IdCandidaturas: IdsCandidacys },
    )

    const newChecks = Object.keys(ListCandidacys).reduce((acc, ids) => {
      acc[ids] = false
      return acc
    }, {})

    await setChecks(newChecks)

    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Candidatura Atualizada',
        msg: `Candidatura de ${IdsCandidacys.length} Selecionados, mudados para "${statusStaff[Number(newStatus)].status}" `,
      },
    ])
  }

  const getHoursRegister = async () => {
    const getHours = await getSubDocuments('events', id, 'workingHours')
    setInfosContext((prev) => ({ ...prev, hoursRegistereds: getHours }))
  }

  const AddWorkingHours = async () => {
    if (!user.user.permissions.staffEvent_addPoint) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    const date = formContext.workingDate
    const time = formContext.workingTime
    const comment = formContext.workingComment

    const dateTime = `${DataComTraçoParaDataComBarra(date)} ${time}`
    const commentToTitle = TransformationforMask(comment, 'title')

    const newRegisterHour = schemaRegisterTimesPoints({ time: dateTime, comment: commentToTitle })

    const query = [{ field: 'status', operator: '>=', value: 5 }]

    const getStaff = await getSubDocumentsWithQuerys('events', id, 'staff', query)

    if (getStaff.length > 0) {
      try {
        await addSubDocument('events', id, 'workingHours', newRegisterHour)
        const rolesStatus = [6, 11]
        const promises = getStaff.map(async (candidacy) => {
          if (!rolesStatus.includes(candidacy.status)) {
            await updateArrayInSubDocument('events', id, 'staff', candidacy.id, 'workingHours', [newRegisterHour], true)
          }
        })

        await Promise.all(promises)
        await getHoursRegister()
        await SetHistoryEvent(id, user.user.nome, `Marcação de Horas Adicionada`, {
          Registro: [newRegisterHour.time, newRegisterHour.comment],
        })
        setAlerts((prev) => [
          ...prev,
          {
            type: 'success',
            title: 'Horas Registradas',
            msg: `A Marcação de hora foi registrada para os colaboradores que estão presentes na staff.`,
          },
        ])
      } catch (error) {
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Erro ao registrar horas',
            msg: `Ocorreu um erro ao registrar as horas para os colaboradores: ${error.message}`,
          },
        ])
      }
    } else {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Staff Não Iniciada',
          msg: `Para registrar um ponto, pelo menos um colaborador deve ter efetuado o check-in.`,
        },
      ])
    }
  }

  const DeleteWorkingHours = async (workingTime) => {
    if (!user.user.permissions.staffEvent_delPoint) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    const idWorkingTime = workingTime.id

    delete workingTime.id

    const query = [{ field: 'status', operator: '>=', value: 5 }]

    const getStaff = await getSubDocumentsWithQuerys('events', id, 'staff', query)
    if (getStaff.length > 0) {
      try {
        await deleteSubDocument('events', id, 'workingHours', idWorkingTime)

        const promises = getStaff.map((candidacy) =>
          updateArrayInSubDocument('events', id, 'staff', candidacy.id, 'workingHours', [workingTime], false),
        )

        await Promise.all(promises)
        await getHoursRegister()
        await SetHistoryEvent(id, user.user.nome, `Marcação de Horas Deletada`, {
          Registro: [workingTime.time, workingTime.comment],
        })
        setAlerts((prev) => [
          ...prev,
          {
            type: 'success',
            title: 'Hora Deletada',
            msg: `A Marcação de hora foi deletada para os colaboradores que estão presentes na staff.`,
          },
        ])
      } catch (error) {
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Erro ao deletar horas',
            msg: `Ocorreu um erro ao registrar as horas para os colaboradores: ${error.message}`,
          },
        ])
      }
    } else {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Staff Não Iniciada',
          msg: `Para registrar um ponto, pelo menos um colaborador deve ter efetuado o check-in.`,
        },
      ])
    }
  }

  const ReadSheetPayment = async () => {
    if (!user.user.permissions.staffEvent_payment) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    await SetHistoryEvent(id, user.user.nome, `Tentativa de importar planilha de pagamentos`)
    const file = formContext?.file_payment
    if (!file) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Arquivo não carregado',
          msg: `Não encontramos uma arquivo, carrege-o novamente e realize uma nova tentativa `,
        },
      ])
    }

    if (!file.name.includes('.xlsx') || !file.name.includes('.xls')) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Formato de arquivo incorreto',
          msg: `Selecione somente arquivo de excel, baixe-o novamente para uma nova tentativa `,
        },
      ])
    }

    const response = await ReadExcelFile(file)

    if (!response?.Pagamentos) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Aba "Pagamentos" não econtrada',
          msg: `Verifique o arquivo enviado e tente novamente`,
        },
      ])
    }

    const headerPagamentos = response.Pagamentos[0]
    const dataPagamentos = response.Pagamentos.slice(1)

    const colPayment = headerPagamentos.indexOf('Pagamento_Realizado')

    if (colPayment === -1) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Coluna "Pagamento_Realizado" não econtrada',
          msg: `Verifique o arquivo enviado e tente novamente`,
        },
      ])
    }
    const colUUID = headerPagamentos.indexOf('Id_Colaborador')
    if (colUUID === -1) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Coluna "Id_Colaborador" não econtrada',
          msg: `Verifique o arquivo enviado e tente novamente`,
        },
      ])
    }

    const paymentExist = dataPagamentos.some((pay) => {
      if (Array.isArray(pay) && pay.length > 0) {
        const value = String(pay[colPayment]).toLocaleLowerCase()

        return value !== 'pago' && value !== 'pendente'
      }
      return false
    })

    if (paymentExist) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Valores na coluna "Pagamento_Realizado" Incorretos',
          msg: `Encontramos valores incorretos na coluna "Pagamento_Realizado", só aceitamos os valores: "pago" e "pendente"`,
        },
      ])
    }

    const newPayments = dataPagamentos
      .map((row) => {
        const uuid = row[colUUID]
        const status = row[colPayment]
        if (status === 'pago') {
          return uuid
        } else {
          return null
        }
      })
      .filter((uuid) => uuid !== null)

    const queryStaff = [{ field: 'status', operator: '==', value: 9 }]

    const paymentsSuccess = []

    const getEvent = await getDocument('events', id)
    const companyData = await getDocument('clientes', clientId)

    const promises = newPayments.map(async (uuid) => {
      const newCandidacy = { status: 10 }
      const newQueryStaff = { field: 'uuid', operator: '==', value: uuid }
      const candidacys = await getSubDocumentsWithQuerys('events', id, 'staff', [...queryStaff, newQueryStaff])

      if (Array.isArray(candidacys) && candidacys.length > 0) {
        const idCandidacys = candidacys.map((cand) => ({ idCandidacy: cand.id, uuid: cand.uuid }))
        const updatePromises = idCandidacys.map(async ({ idCandidacy, uuid }) => {
          await updateSubDocument('events', id, 'staff', idCandidacy, newCandidacy)
          paymentsSuccess.push(uuid)
          return null
        })
        await Promise.all(updatePromises)

        const notificationFields = {
          title: 'Pagamento Realizado',
          description: `Uhuu, Você recebeu seu cachê do evento: ${getEvent.name} - ${getEvent.round}, caso não tenha recebido, entre em contato com a empresa ${companyData.nomeFantasia} no telefone ${companyData.responsavel_telefone}.`,
        }

        await sendNotification(paymentsSuccess, [], notificationFields.title, notificationFields.description)
        return null
      }
    })

    Promise.all(promises)
      .then(() => {
        FetchGetdatas()
        if (paymentsSuccess.length > 0) {
          SetHistoryEvent(id, user.user.nome, 'Planilha de Pagamentos Importada', {
            Pagamentos_Realizados: paymentsSuccess,
          })
          setModalUploadPayments(false)
          setFormContext((prev) => ({ ...prev, file_payment: null }))
          return setAlerts((prev) => [
            ...prev,
            {
              type: 'success',
              title: 'Planilha de Pagamentos Importada',
              msg: `A Planilhas de pagamentos foi importada com sucesso, e os pagamentos foram realizados conforme a planilha.`,
            },
          ])
        } else {
          SetHistoryEvent(
            id,
            user.user.nome,
            'Planilha de Pagamentos importada com sucesso. Observação: todos os pagamentos já estavam marcados como realizados.',
          )
          setModalUploadPayments(false)
          setFormContext((prev) => ({ ...prev, file_payment: null }))
          return setAlerts((prev) => [
            ...prev,
            {
              type: 'success',
              title: 'Planilha de Pagamentos Importada',
              msg: `A Planilhas de pagamentos foi importada com sucesso. Observação: todos os pagamentos já estavam marcados como realizados.`,
            },
          ])
        }
      })
      .catch((error) => console.error('Erro nas atualizações:', error))
  }

  const FetchQueryDatas = async () => {
    await TryCatch(queryData, setLoading, setAlerts)
  }

  const FetchClearQueryData = async () => {
    await TryCatch(clearQueryData, setLoading, setAlerts)
  }

  const FetchGetdatas = async (pageQuery = null) => {
    await TryCatch(
      () => {
        getDatas({ pageQuery: page })
      },
      setLoading,
      setAlerts,
    )
  }

  const FetchGetInfos = async () => {
    await TryCatch(getInfos, setLoading, setAlerts)
  }

  const HandleUpdateStatusCandidacy = async (status, valuesCandidacy) => {
    await TryCatch(
      () => {
        UpdateStatusCandidacy(status, valuesCandidacy)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleUpdateStatusMultipleCandidacy = async (status, ListCandidacys) => {
    await TryCatch(
      async () => {
        await UpdateStatusMultipleCandidacy(status, ListCandidacys)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleFavoriteColaborator = async (uuidColab) => {
    await TryCatch(
      async () => {
        await favoriteColaborator(uuidColab)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleBlockUnBlockColaborator = async (uuidColab) => {
    await TryCatch(
      async () => {
        await blockUnBlockColaborator(uuidColab)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleUpdateValuesInfoCandidacy = async (value) => {
    await TryCatch(
      () => {
        updateValuesInfoCandidacy(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleAddWorkingHours = async () => {
    await TryCatch(AddWorkingHours, setLoading, setAlerts)
  }

  const HandleDeleteWorkingHours = async (values) => {
    await TryCatch(
      () => {
        DeleteWorkingHours(values)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleInviteTeams = async (value) => {
    await TryCatch(
      () => {
        inviteTeams(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleExportExcelPayment = async () => {
    if (!user.user.permissions.staffEvent_exportSheets) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    await TryCatch(
      async () => {
        await HandleExportPaymentSheet(id, setLoading, setAlerts)
      },
      setLoading,
      setAlerts,
    )
    await SetHistoryEvent(id, user.user.nome, `Planilha de Pagamentos extraida`)
  }

  const HandleExportAllWorkingTimeRegister = async () => {
    if (!user.user.permissions.staffEvent_exportSheets) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    await TryCatch(
      () => {
        ExportAllWorkingTimeRegister(id, setAlerts)
      },
      setLoading,
      setAlerts,
    )
    await SetHistoryEvent(id, user.user.nome, `Planilha de Registro de Horas Exportada`)
  }

  const HandleReadSheetPayment = async () => {
    await TryCatch(ReadSheetPayment, setLoading, setAlerts)
  }

  const HandleGetDataFavorites = async () => {
    await TryCatch(getDataFavorites, setLoading, setAlerts)
  }

  const HandleAddCandidacy = async (values) => {
    await TryCatch(
      async () => {
        await addCandidacy(values)
      },
      setLoading,
      setAlerts,
    )
  }

  const ActionForButtonsCandidates = (value) => {
    return {
      setAccept: async () => {
        await HandleUpdateStatusCandidacy(2, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Candidatura Aprovada',
          description: 'Parabéns, sua candidatura foi aprovada! Entre na aba de candidaturas para aceitar o convite.',
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setReject: async () => {
        await HandleUpdateStatusCandidacy(1, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Candidatura Rejeitada - ' + formContext.name,
          description: `Agradecemos sua candidatura, mas após avaliarmos o seu perfil optamos por seguir com outros candidatos. Boa sorte nas próximas candidaturas!`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setCheckin: async () => {
        await HandleUpdateStatusCandidacy(5, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Check-in Realizado - ' + formContext.name,
          description: `Seu check-in foi realizado no evento.`,
        }

        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setCheckout: async () => {
        await HandleUpdateStatusCandidacy(7, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Check-out Realizado - ' + formContext.name,
          description: `Seu check-out foi realizado no evento.`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setPay: async () => {
        await HandleUpdateStatusCandidacy(10, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Pagamento Realizado - ' + formContext.name,
          description: `Seu pagamento foi realizado pela empresa e pode levar até 24h para o débito. Verifique no seu banco cadastrado e informe a empresa após o período informado caso não tenha recebido.`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setCancel: async () => {
        await HandleUpdateStatusCandidacy(11, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Candidatura Cancelada - ' + formContext.name,
          description: `Sua candidatura para a vaga "${(value?.jobOffer?.position?.nome || value?.jobOffer?.position?.name || '').toUpperCase()}" foi cancelada.`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setRecover: async () => {
        await HandleUpdateStatusCandidacy(2, value)

        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]

        const notificationFields = {
          title: 'Candidatura Recuperada',
          description: `Sua candidatura para a vaga "${(value?.jobOffer?.position?.nome || value?.jobOffer?.position?.name || '').toUpperCase()}" foi recuperada.`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
      },
      setNotify: async () => {
        const uuidAsArray = [value.uuid]
        const tokenAsArray = [value?.collabData?.token]
        const notificationFields = {
          title: 'Aguardando Confirmação de Presença',
          description: `Estamos Aguardando sua confirmação de presença na candidatura para a vaga "${(value?.jobOffer?.position?.nome || value?.jobOffer?.position?.name || '').toUpperCase()}", dia ${DataComTraçoParaDataComBarra(value?.jobOffer?.date)} - ${value?.jobOffer?.round}`,
        }
        await sendNotification(uuidAsArray, tokenAsArray, notificationFields.title, notificationFields.description)
        // setAlerts((prev) => [
        //   ...prev,
        //   {
        //     type: 'success',
        //     title: 'Notificação Enviada',
        //     msg: `Sua Notificação foi enviada ao staff:  ${value.name}.`,
        //   },
        // ])
      },
    }
  }

  const ActionForButtonsMultiplesCandidates = (Idschecks) => {
    return {
      setAccept: async () => {
        await HandleUpdateStatusMultipleCandidacy(2, Idschecks)

        const notificationFields = {
          title: 'Candidatura Aprovada - ' + formContext.name,
          description: 'Parabéns, sua candidatura foi aprovada! Entre na aba de candidaturas para aceitar o convite.',
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setReject: async () => {
        await HandleUpdateStatusMultipleCandidacy(1, Idschecks)

        const notificationFields = {
          title: 'Candidatura Rejeitada - ' + formContext.name,
          description: `Agradecemos sua candidatura, mas após avaliarmos o seu perfil optamos por seguir com outros candidatos. Boa sorte nas próximas candidaturas!`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setCheckin: async () => {
        await HandleUpdateStatusMultipleCandidacy(5, Idschecks)

        const notificationFields = {
          title: 'Check-in Realizado - ' + formContext.name,
          description: `Seu check-in foi realizado no evento.`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setCheckout: async () => {
        await HandleUpdateStatusMultipleCandidacy(7, Idschecks)

        const notificationFields = {
          title: 'Check-out Realizado - ' + formContext.name,
          description: `Seu check-out foi realizado no evento.`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setPay: async () => {
        await HandleUpdateStatusMultipleCandidacy(10, Idschecks)

        const notificationFields = {
          title: 'Pagamento Realizado - ' + formContext.name,
          description: `Seu pagamento foi realizado pela empresa e pode levar até 24h para o débito. Verifique no seu banco cadastrado e informe a empresa após o período informado caso não tenha recebido.`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setCancel: async () => {
        await HandleUpdateStatusMultipleCandidacy(11, Idschecks)

        const notificationFields = {
          title: 'Candidatura Cancelada - ' + formContext.name,
          description: `Sua candidatura para a vaga foi cancelada.`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setRecover: async () => {
        await HandleUpdateStatusMultipleCandidacy(2, Idschecks)

        const notificationFields = {
          title: 'Candidatura Recuperada - ' + formContext.name,
          description: `Sua candidatura para a vaga foi recuperada.`,
        }
        await sendNotification(
          allUuidsListCheckeds,
          allTokensListCheckeds,
          notificationFields.title,
          notificationFields.description,
        )
      },
      setNotify: async () => {
        const withoutToken = checked
          .filter((c) => !c?.collabData?.token)
          .map((c) => ({ id: c.id, uuid: c.uuid, name: c.name, cpf: c.cpf }))
        if (withoutToken.length > 0) {
          console.log(`[setNotify] ${withoutToken.length} colaborador(es) sem token:`, withoutToken)
        }
        const validUuids = allUuidsListCheckeds.filter(Boolean)
        const validTokens = allTokensListCheckeds.filter(Boolean)
        const notificationFields = {
          title: 'Aguardando Confirmação de Presença - ' + formContext.name,
          description: `Estamos Aguardando sua confirmação de presença na candidatura para a vaga`,
        }
        await sendNotification(validUuids, validTokens, notificationFields.title, notificationFields.description)
        setAlerts((prev) => [
          ...prev,
          {
            type: 'success',
            title: 'Notificação Enviada',
            msg: `Sua Notificação foi enviada a ${validUuids.length} Staff(s). ${withoutToken.length} sem token (veja console).`,
          },
        ])
      },
    }
  }

  const ActionForModalInfoColaborator = () => {
    return {
      setFavorite: async (uuid) => {
        await HandleFavoriteColaborator(uuid)
      },
      setBlocked: async (uuid) => {
        await HandleBlockUnBlockColaborator(uuid)
      },
    }
  }

  const SetValuesInfoCandidacy = (values) => {
    if (!user.user.permissions.staffEvent_viewInfoColab) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    setFormContext((prev) => ({ ...prev, infoCandidacySelected: values }))
    setModalInfoCandidacy(true)
  }

  const [teamsList, setTeamsList] = useState([])

  useEffect(() => {
    const updateData = async (newPage) => {
      if (newPage !== '') {
        await FetchGetInfos()
        await FetchGetdatas(newPage)
      }
    }
    updateData(page)
  }, [page])

  useEffect(() => {
    if (checkAll && filter.status && filter.status !== 'todos') {
      const visibleChecked = Object.fromEntries(dataStaffFiltered.map((item) => [item.id, true]))
      setChecks(visibleChecked)
    } else if (!checkAll) {
      setChecks({})
    }
  }, [checkAll, filter.status])

  useEffect(() => {
    setChecks({})
    setCheckall(false)
  }, [filter])

  useEffect(() => {
    if (formContext?.CandidacyRegisterWorkingHours && formContext?.CandidacyRegisterWorkingHours !== '') {
      getHoursRegister()
    }
  }, [formContext])

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries())
    setFilter((prev) => ({
      ...prev,
      ...params,
    }))
  }, [])

  useEffect(() => {
    if (!dataStaff?.length) return
    handleFilter(dataStaff)
  }, [dataStaff])

  return {
    id,
    user,
    clientId,
    page,
    setPage,
    setAlerts,
    loading,
    setLoading,
    filter,
    setFilter,
    checks,
    checkAll,
    setCheckall,
    setChecks,
    formContext,
    setFormContext,
    FetchGetInfos,
    FetchGetdatas,
    infosContext,
    setInfosContext,
    dataContext,
    FetchQueryDatas,
    FetchClearQueryData,
    HandleUpdateStatusCandidacy,
    ActionForButtonsCandidates,
    ActionForButtonsMultiplesCandidates,
    modalInvite,
    setModalInvite,
    modalInfoCandidacy,
    setModalInfoCandidacy,
    SetValuesInfoCandidacy,
    ActionForModalInfoColaborator,
    checkFavoriteColaborator,
    HandleUpdateValuesInfoCandidacy,
    exportAllData,
    criar1000Candidaturas,
    teamsList,
    HandleInviteTeams,
    HandleExportExcelPayment,
    HandleReadSheetPayment,
    modalUploadPayments,
    setModalUploadPayments,
    modalRegisterWorkingHours,
    setModalRegisterWorkingHours,
    HandleAddWorkingHours,
    HandleDeleteWorkingHours,
    HandleExportAllWorkingTimeRegister,
    modalAdd,
    setModalAdd,
    HandleGetDataFavorites,
    searchFavorite,
    setSearchFavorite,
    HandleAddCandidacy,
    dataStaffFiltered,
    optionsFilter,
    setOptionsFilter,
    handleFilter,
    showFilters,
    setShowFilters,
    filterConfigs,
    getFilterLabel,
  }
}
